// src/App.jsx
import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { BrowserRouter as Router, Routes, Route, Link, Outlet } from "react-router-dom";
import Login from './SchoolPanel/Screen/login';
import CoursesTests from './SchoolPanel/Screen/step1';
import Step2 from './SchoolPanel/Screen/step2';
import Step3 from './SchoolPanel/Screen/step3';
 

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
            
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="step1" element={<CoursesTests />} />
                <Route path="step2" element={<Step2 />} />
                <Route path="step3" element={<Step3 />} />
                <Route path="/SchoolPanel" element={<Login />}>
                    {/* ✅ Child Routes */}
                  
                     
                </Route>
                 
                {/* <Route path="*" element={<NotFound />} />  */}
            </Routes>
        </Router>
    
       
    </ThemeProvider>
  );
}

export default App;
